<template>
  <div class="d-flex align-center question-block white mb-2">
    <VIcon
      v-if="$vuetify.breakpoint.smAndDown"
      class="handle pa-4 pr-2 text--disabled"
    >
      mdi-menu
    </VIcon>
    <div class="question-number pa-2 py-md-5 px-md-7 text--disabled">
      {{ index + 1 }}
    </div>
    <div class="question-row pa-2 px-md-6">
      {{ q.question }}
    </div>
    <div class="question-action pa-2 px-md-6 d-flex justify-end align-center ml-auto">
      <VacancyQuestionTextPreview v-if="q.type === 'text_question' && showPreview" :question="q" class="d-none d-md-block" />
      <span
        v-if="q.type === 'text_question'"
        class="grey--text"
      >
        TXT
      </span>
      <VBtn
        v-if="q.type === 'text_question'"
        text
        icon
        small
        @click="showEditForm"
      >
        <VIcon>
          mdi-pencil-outline
        </VIcon>
      </VBtn>

      <VBtn
        text
        icon
        small
        @click="destroy"
      >
        <VIcon class=" text--disabled">
          mdi-trash-can-outline
        </VIcon>
      </VBtn>
    </div>
    <VDialog
      v-if="editing"
      v-model="editDialog"
      max-width="500"
      @click:outside="closeEditForm"
      @keydown.esc="closeEditForm"
    >
      <VCard class="pa-5">
        <VTextarea
          v-model="newQuestion"
          outlined
          dense
          :label="$t('question')"
          :hint="$t('questionHint')"
          :counter="200"
          :error-messages="errors.question"
        />
        <div class="text-right">
          <VBtn color="success" outlined @click="closeEditForm">
            {{ $t('close') }}
          </VBtn>
          <VBtn
            color="success"
            class="ml-2"
            elevation="0"
            @click="edit"
          >
            {{ $t('save') }}
          </VBtn>
        </div>
      </VCard>
    </VDialog>
  </div>
</template>

<script>
import VacancyQuestionTextPreview from '@/components/Vacancy/VacancyQuestionTextPreview';
import ValidationMixin from '../../mixins/ValidationMixin';

export default {
  name: 'VacancyQuestionRow',
  components: { VacancyQuestionTextPreview },
  mixins: [ValidationMixin],
  props: {
    question: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    showPreview: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  data() {
    return {
      q: { ...this.question },
      editing: false,
      newQuestion: this.question.question,
      editDialog: false,
    };
  },
  watch: {
    question() {
      this.q = this.question;
      this.newQuestion = this.question.question;
    },
  },
  methods: {
    showEditForm() {
      this.editing = true;
      this.editDialog = true;
    },

    closeEditForm() {
      this.editing = false;
      this.editDialog = false;
    },

    edit() {
      if (this.q.type !== 'text_question') {
        return null;
      }

      this.q.question = this.newQuestion;
      this.$emit('updated', this.q);
      this.closeEditForm();
    },

    async destroy() {
      return this.$emit('destroy', this.q);
    },
  },
};
</script>
<style lang="scss" scoped>
.question-block {
  width: 100%;
}

.question-number {
  color: #757575;
  text-align: center;
  font-size: 20px;
  font-weight: 400;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 75px;
  width: 100%;
  height: 100%;
  @media screen and (max-width: 460px) {
    font-size: 15px;
    width: auto;
  }

  @media #{map-get($display-breakpoints, 'md-and-up')} {
    border-right: 8px dotted #fafafa;
  }
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .question-block {
    .question-action {
      max-width: 102px;
    }
  }
}

.v-banner {
  &::v-deep {
    .v-banner__text {
      width: 100%;
    }
  }
}
</style>
<i18n locale="en" lang="yaml">
  close: Close
  save: Save
  question: Ask custom question
  questionHint: The maximum number of characters is 200
  preview: Preview
</i18n>

<i18n locale="ru" lang="yaml">
  close: Закрыть
  save: Сохранить
  question: Задайте свой вопрос в свободной форме
  questionHint: Максимальное количество символов - 200
  preview: Предпросмотр
</i18n>
